export const generalKey = 'product_ac_wave3';
export const whiteLocaleList = ['us', 'ca', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'jp', 'au', 'nl']; //白名单
export const productPageUrl = 'wave-3-portable-air-conditioner';
export const tabsValues = ['Product', 'Bundles'];
export const productPageTheme = 'white'; //主题色
